import { ReactNode } from 'react';

import { Chip } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import { RiCloseLine as CloseIcon } from '@remixicon/react';

import { FilterViewer } from './FilterViewer';
import { useFilterChipStyles } from './filterChipStyles';
import { FilterViewerComponentProps } from './provider';

export interface FilterChipProps<T> extends FilterViewerComponentProps<T> {
  label: ReactNode;
  loading?: boolean;
}

export const FilterChip = <T,>(props: FilterChipProps<T>) => {
  const { label, loading, ...rest } = props;
  const classes = useFilterChipStyles();

  if (loading) {
    return <ChipSkeleton />;
  }

  return (
    <FilterViewer {...rest}>
      {({ onRemove, onEdit }) => (
        <Chip
          className={classes.focusRing}
          label={label}
          onDelete={onRemove}
          onClick={onEdit}
          deleteIcon={<CloseIcon />}
        />
      )}
    </FilterViewer>
  );
};

function ChipSkeleton() {
  return (
    <Skeleton
      variant="rect"
      style={{ borderRadius: 99999 }}
      data-testid="filter-chip-skeleton"
    >
      <Chip label="Loading..." deleteIcon={<CloseIcon />} />
    </Skeleton>
  );
}
